module.exports = __webpack_public_path__ + "static/camera1-82f6bd53822d6437edd23457f0191663.jpg";